import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import {
  Outlet,
  Link,
  createRootRouteWithContext,
  useRouter,
} from "@tanstack/react-router";
import { Toaster } from "@/components/ui/sonner";

function NotFoundComponent() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F8F9FA] px-4">
      <div className="max-w-md text-center">
        <h1 className="text-7xl font-bold text-[#111827]">404</h1>
        <h2 className="mt-4 text-xl font-semibold text-[#111827]">Page not found</h2>
        <p className="mt-2 text-sm text-[#6B7280]">
          The page you're looking for doesn't exist.
        </p>
        <div className="mt-6">
          <Link
            to="/merchants"
            className="inline-flex items-center justify-center rounded-md bg-[#0F172A] px-4 py-2 text-sm font-medium text-white hover:bg-[#1E293B]"
          >
            Back to backoffice
          </Link>
        </div>
      </div>
    </div>
  );
}

function ErrorComponent({ error, reset }: { error: Error; reset: () => void }) {
  console.error(error);
  const router = useRouter();

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F8F9FA] px-4">
      <div className="max-w-md text-center">
        <h1 className="text-xl font-semibold tracking-tight text-[#111827]">
          This page didn't load
        </h1>
        <p className="mt-2 text-sm text-[#6B7280]">Something went wrong.</p>
        <div className="mt-6 flex flex-wrap justify-center gap-2">
          <button
            onClick={() => {
              router.invalidate();
              reset();
            }}
            className="inline-flex items-center justify-center rounded-md bg-[#0F172A] px-4 py-2 text-sm font-medium text-white hover:bg-[#1E293B]"
          >
            Try again
          </button>
        </div>
      </div>
    </div>
  );
}

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: RootComponent,
  notFoundComponent: NotFoundComponent,
  errorComponent: ErrorComponent,
});

function RootComponent() {
  const { queryClient } = Route.useRouteContext();
  return (
    <QueryClientProvider client={queryClient}>
      <Outlet />
      <Toaster position="top-right" />
    </QueryClientProvider>
  );
}
